import { useMediaQuery } from '@/hooks/useMediaQuery';

import { Text } from './HelperText.styles';

interface HelperTextProps {
  helperText: string;
  hasError?: boolean;
}

export const HelperText: React.FC<HelperTextProps> = ({
  helperText,
  hasError
}) => {
  const isMobile = useMediaQuery('mobile');

  return (
    <Text $hasError={hasError} variant={isMobile ? 'caption1' : 'body2'}>
      {helperText}
    </Text>
  );
};
